const Research3Text = (
  <div>
    <h1>Probing Quantum Phenomena:</h1>
    <p className="individualResearchBody">
      With access to rich atomic level structural information and insights into
      the impurities present, the missing piece to systematically improving the 
      performance of quantum systems is understanding local properties. I apply 
      advanced microscopy and diffraction techniques to observe exotic phenomena 
      and states that can be harnessed for storing and manipulating information. 
      This involves the use of electron microscopy techniques such as differential 
      phase contrast, Lorentz TEM, and electron holography as well as scanning 
      probe microscopy techniques such as scanning tunneling microscopy and 
      microwave impedance microscopy at room and cryogenic temperatures.  
    </p>
  </div>
);

const Research3Publication1 = (
  <div>
    Bal, M.*; <b>Murthy, A. A.</b>*; Zhu, S.*; Crisa, F.*;...Romanenko, A.,
    Grassellino, A., Systematic Improvements in Transmon Qubit Coherence Enabled 
    by Niobium Surface Encapsulation. <i>arXiv:2304.13257</i> {" "}
    <a href="https://arxiv.org/abs/2304.13257">
      [HTML]
    </a>
  </div>
);

const Research3Publication2 = (
  <div>
    <b>Murthy, A. A.</b>; Stanev, T. K.; Ribet, S. M.; Watanabe, K.; Taniguchi,
    T.; Stern, N. P.; dos Reis, R.; Dravid, V. P., Spatial Mapping of
    Electrostatic Fields across 2D Heterostructures. <i>Nano Lett.</i> 21 (17),{" "}
    <b>2021</b>, 7131-7137{" "}
    <a href="https://pubs.acs.org/doi/abs/10.1021/acs.nanolett.1c01636">
      [HTML]
    </a>
  </div>
);

export { Research3Text, Research3Publication1, Research3Publication2 };
